import Icon1 from "@assets/icons/Icon";
import { useState, useEffect } from "react";
import { MobileAppModal } from "@components/modals/MobileAppModal";

export function MobileAppFloatingButton() {
  const [showModal, setShowModal] = useState(false);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="fixed bottom-6 right-20 z-40 w-12 h-12 bg-white rounded-full shadow-lg border border-neutral-200 flex items-center justify-center cursor-pointer hover:shadow-xl hover:scale-105 transition-all duration-200"
        title="Télécharger l'application mobile"
      >
        <Icon1 name="smartphone" size={22} color="black" />
        {animate && <span className="ping-ring" />}
      </button>
      {showModal && <MobileAppModal onClose={() => setShowModal(false)} />}

      <style>{`
        .ping-ring {
          position: absolute;
          inset: -3px;
          border-radius: 9999px;
          border: 2px solid #3b82f6;
          animation: ping-circle 1.4s cubic-bezier(0, 0, 0.2, 1) 3;
          pointer-events: none;
        }
        @keyframes ping-circle {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
}
